import { TranslationObject } from './en';

export const langIt: TranslationObject = {
  'common.expected_finish': 'Fine Prevista',
  'common.minutes': 'min',
  'common.now': 'Adesso',
  'common.next': 'Prossimo',
  'common.public_message': 'Messaggio pubblico',
  'common.scheduled_start': 'Inizio programmato',
  'common.scheduled_end': 'Fine programmata',
  'common.projected_start': 'Inizio previsto',
  'common.projected_end': 'Fine prevista',
  'common.stage_timer': 'Orologio Palco',
  'common.started_at': 'Iniziato Alle',
  'common.time_now': 'Ora attuale',
  'common.no_data': 'Nessun dato disponibile',
  'countdown.ended': 'Evento finito alle',
  'countdown.running': 'Evento in corso',
  'countdown.select_event': 'Seleziona un evento da seguire',
  'countdown.to_start': 'Tempo alla partenza',
  'countdown.waiting': "In attesa dell'inizio dell'evento",
  'countdown.overtime': 'in ritardo',
  'timeline.live': 'live',
  'timeline.done': 'Terminato',
  'timeline.due': 'previsto',
  'timeline.followedby': 'Seguito da',
  'project.title': 'Titolo',
  'project.description': 'Descrizione',
  'project.backstage_info': 'Informazioni di backstage',
  'project.backstage_url': 'URL di backstage',
  'project.public_info': 'Informazioni pubbliche',
  'project.public_url': 'URL pubblico',
};
